import { COLORS } from '@/constants/COLORS';
import { FC } from 'react';
import { ReactComponent as TickIcon } from '@/assets/tick-icon.svg';
import ColorOption from './ColorOption';

const COLOR_OPTIONS = [
  COLORS.redDarker,
  COLORS.orangeDark,
  COLORS.yellowLight,
  COLORS.greenNotes,
  COLORS.cyan,
  COLORS.blueElectric,
  COLORS.brown,
  COLORS.pink,
  COLORS.white,
];

const DEFAULT_VALUE = null;
const DEFAULT_COLOR = COLORS.purpleGrayDark;

interface ColorPickerProps {
  onSelectedColor: (value: string | null) => void;
  selectedColor?: string | null;
}
const ColorPicker: FC<ColorPickerProps> = ({ onSelectedColor, selectedColor }) => {
  return (
    <div className="flex flex-wrap gap-2">
      <ColorOption color={DEFAULT_COLOR} onClick={() => onSelectedColor(DEFAULT_VALUE)} showCrossLine />
      {COLOR_OPTIONS.map((color: string) => {
        return (
          <ColorOption onClick={() => onSelectedColor(color)} color={color} className="text-white">
            {selectedColor === color && <TickIcon className="h-4 w-4" />}
          </ColorOption>
        );
      })}
    </div>
  );
};

export default ColorPicker;
